module.exports = __webpack_public_path__ + "static/media/35-8.1c1f9a6a.mp3";